import React from "react";
import AdminServiceTickets from "../../components/dashboard/AdminServiceTickets";

const AdminPlatformGest = () => (
  <AdminServiceTickets
    serviceCode="management"
    title="Facturation"
    lead="Les demandes liées au module de facturation de Gestion 360."
  />
);

export default AdminPlatformGest;
